import { StyleSheet } from '@react-pdf/renderer';
import { colorsApp } from 'src/redux/reducers/theme';

const colors = colorsApp['light'];

export const cardStyles = StyleSheet.create({
  column: {
    display: 'flex',
    flexDirection: 'column',
    width: '33%',
    height: 86,
  },
  label: {
    fontSize: 8,
    fontWeight: 500,
    fontFamily: 'Poppins',
    color: colors.prussianBlue,
  },
  labelSmall: {
    fontSize: 7,
    fontWeight: 500,
    fontFamily: 'Poppins',
    color: colors.prussianBlue,
  },
  subLabel: {
    fontSize: 7.4,
    fontWeight: 500,
    fontFamily: 'Poppins',
    color: colors.cflowerBlue,
  },
  subLabelItalic: {
    fontSize: 6.5,
    fontWeight: 500,
    fontFamily: 'Poppins',
    color: colors.cflowerBlue,
    fontStyle: 'italic',
  },
  value: {
    fontSize: 15,
    fontWeight: 600,
    fontFamily: 'Poppins',
    color: colors.prussianBlue,
    marginBottom: -4,
  },
  // Control Implementation specific styles
  legendRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
    marginBottom: 2,
  },
  legendRowLast: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  legendRowSpaced: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
    marginBottom: 8,
  },
  separator: {
    flex: 1,
    height: 1,
    backgroundColor: colors.stroke,
  },
  legendLabel: {
    fontSize: 7,
    fontWeight: 500,
    fontFamily: 'Poppins',
    color: colors.cflowerBlue,
  },
  legendValue: {
    fontSize: 7,
    fontWeight: 600,
    fontFamily: 'Poppins',
  },
  chartContainer: {
    width: 86,
    height: 86,
    flexShrink: 0,
  },
  legendSection: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    paddingBottom: 8,
  },
  // Overdue Reviews chip
  overdueChip: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    borderRadius: 2,
    paddingTop: 3,
    paddingRight: 5,
    paddingBottom: 1,
    paddingLeft: 5,
    backgroundColor: colors.statusRed,
    alignSelf: 'flex-start',
  },
  overdueValue: {
    fontSize: 15,
    fontWeight: 600,
    fontFamily: 'Poppins',
    color: colors.white,
  },
  overdueLabel: {
    fontSize: 11,
    fontWeight: 500,
    fontFamily: 'Poppins',
    color: colors.white,
  },
});
